import React, { Fragment, Component } from 'react';
import { Redirect } from 'react-router-dom';
import Alert from 'react-bootstrap/Alert';
import Container from 'react-bootstrap/Container';
import Jumbotron from 'react-bootstrap/Jumbotron';
import authService from '../../services/AuthService';
import api, { apiErrorHandler, apiResponseHandler } from '../../services/AxiosService';
import queryString from 'query-string';
import { alertPopup, apiErrorPopup } from '../../helpers/MessagePopup';
import tourDef from '../../productTour/TourDef';

import './Login.css';

import cadeHeader from '../../content/CADEAIHeader.png';
import { isNullOrEmpty } from '../../helpers/LanguageHelpers';

const logoPath = "/content/CorbettLogo.png";


/*
 * CognitoRedirect gets a redirect from Cognito on successful authentication.  
 * It then needs to parse the querystring and call the rest server to build a 
 * model and get the user into the system.
 */

export class CognitoRedirect extends Component {

    constructor(props) {
        super(props);

        this.state = {
            redirectPage: null,
            alertTitle: null,
            alertMessage: null
        }

        authService.clearAuthenticated();
    }
    componentDidMount = () => {

        // token is ....#id_token=<token>&access_token=<token>&expires_in=3600&token_type=Bearer
        let urlHash = this.props.location.hash;

        let id_token = urlHash.substring(urlHash.indexOf("id") + 9);
        id_token = id_token.substring(0, id_token.indexOf("&"));
        let access_token = urlHash.substring(urlHash.indexOf("access") + 13);
        access_token = access_token.substring(0, access_token.indexOf("&"));

        let cognito_code = "cognito";

        // The user is authenticated at this point.  Call the rest server to discover the user, build and model and return it.  Then the normal login flow will continue.
        api.post("account/cognito", {
            CognitoCode: cognito_code,
            IdToken: id_token,
            AccessToken: access_token
        })
            .then(response => {

               console.log('Response:', response); // <-- This prints the response

                if (response.status == 200) {
                    
                    if (!isNullOrEmpty(response.data.redirectUrl)) {
                        // We are redirecting to an external site
                        this.setState({ redirectPage: response.data.redirectUrl, alertTitle: response.data.alertTitle, alertMessage: response.data.alertMessage });
                    }
                    else {

                        // Set the tour run state in the singleton
                        tourDef.setRunTours(response.data.runTours);

                        // Retain authenticated user information in the authService.  
                        authService.setAuthenticated(response.data.token, response.data.accessToken, response.data.id, response.data.userName, response.data.userFirstName, response.data.userLastName,
                            response.data.userDegrees, response.data.isGuest, response.data.isRater1, response.data.isRater2, response.data.isRater3,
                            response.data.isPartnerProvider, response.data.partnerRole, response.data.restrictedDomains);

                        if (response.data.page == "/cade") {
                            // Setup person lists and assessment lists if the user is going beyond getting started or home

                            // Set the assessment state (accessible assessments, current assessment, etc.) in App.js passively (no render wanted)
                            this.props.assessmentStateHandler(response.data.personFirstName, response.data.personLastName, response.data.personBirthDate, response.data.personAge,
                                response.data.assessmentsModel.assessments, response.data.providerId, response.data.assessmentId, response.data.assessmentDate);

                            // Set the personList into app.js state (passively - no render wanted)
                            this.props.personListHandler(response.data.personListModel.personList);
                        }

                        // If there's a message to display, do it.
                        if (!isNullOrEmpty(response.data.alertMessage)) {
                            alertPopup('info', response.data.alertMessage);
                        }
                        // Set state to force a re-render that will redirect through App.js
                        this.setState({ redirectPage: response.data.cadeFirstPage });
                    }
                }
                else {
                    // Could be user with a cognito account but not a cade account
                    let errorMessage = apiResponseHandler(response);
                    apiErrorPopup(errorMessage);
                    //this.setState({ redirectPage: "/" });
                }
            })
            .catch(error => {
                let errorMessage = apiErrorHandler(error);
                apiErrorPopup("CADE AUTISM TEST Login Error: " + errorMessage);
                //this.setState({ redirectPage: "/" });
            });
    }

    render() {

        // BEWARE debugging in certain places (like the render method.  It gets optimized away and you undefined for lots of things when they really aren't!

        // If the user is already authenticated, redirect to the home page.  The only way they get to be here is if they are not authenticated.
        let alertTitle = isNullOrEmpty(this.state.alertTitle) ? "Attention!" : this.state.alertTitle;
        if (this.state.redirectPage == null) {
            return (null);
        }
        else if (this.state.redirectPage.includes("https")){
            return (
                
                <Fragment>
                    <Jumbotron bsPrefix="jumbotron login_redirect" fluid={false}>
                        <img src={logoPath} />
                        <Container>
                            <h1>{alertTitle}</h1>
                            <p>
                                {this.state.alertMessage}
                            </p>
                            <hr />
                            <Alert key={this.state.redirectPage} variant="info">
                                <Alert.Link href={this.state.redirectPage}>Click to update your account</Alert.Link>
                            </Alert>
                        </Container>
                    </Jumbotron>
                </Fragment>
            );
        }
        else {
            if (authService.isAuthenticated) {
                return (<Redirect to={this.state.redirectPage} />);
            }
            else {
                return (<Redirect to="/" />);
            }
        }
    }
}

export default CognitoRedirect;




// WEBPACK FOOTER //
// ./src/components/Login/CognitoRedirect.js